export default "__VITE_ASSET__C69HgEWt__"